(function () {
  let activeInstance = null;
  let globalListenersInitialized = false;

  function registerGlobalListeners() {
    if (globalListenersInitialized) return;
    globalListenersInitialized = true;

    document.addEventListener('click', function (e) {
      if (!activeInstance) return;
      const { container, isMobile, isOpen, closeModal } = activeInstance;
      if (!isMobile()) return;
      if (!isOpen) return;
      if (container.contains(e.target)) return;
      closeModal();
      activeInstance = null;
    });

    document.addEventListener('keydown', function (e) {
      if (!activeInstance) return;
      const { isOpen, closeModal } = activeInstance;
      if (e.key === 'Escape' && isOpen) {
        closeModal();
        activeInstance = null;
      }
    });
  }

  function wireUp(container) {
    if (!container || container.dataset.rigorInit === 'true') return;
    container.dataset.rigorInit = 'true';

    var btn = container.querySelector('.rigor-info-tooltip-btn');
    var modal = container.querySelector('.rigor-tooltip-modal');
    var closeBtn = container.querySelector('.rigor-tooltip-close');
    var content = container.querySelector('.rigor-tooltip-content');

    if (!btn || !modal || !closeBtn || !content) return;

    var isOpen = false;
    var lastFocused = null;
    var hoverTimeout;
    var suppressHover = false;

    function isMobile() {
      return window.innerWidth <= 767;
    }

    function clearHover() {
      clearTimeout(hoverTimeout);
    }

    function updateMobilePosition() {
      if (!isMobile()) return;

      var leftOffset = container.getBoundingClientRect().left;
      modal.style.left = (-leftOffset) + 'px';

      var btnRect = btn.getBoundingClientRect();
      var modalRect = modal.getBoundingClientRect();

      if (btnRect.width && modalRect.width) {
        var arrowCenter = btnRect.left + (btnRect.width / 2) - modalRect.left;
        var min = 16;
        var max = modalRect.width - 16;
        var clamped = Math.max(min, Math.min(max, arrowCenter));
        modal.style.setProperty('--rigor-arrow-left', clamped + 'px');
      }
    }

    function openModal() {
      if (isOpen) return;
      isOpen = true;

      lastFocused = document.activeElement;

      modal.removeAttribute('hidden');
      btn.setAttribute('aria-expanded', 'true');

      if (isMobile()) {
        updateMobilePosition();
      } else {
        resetDesktopPosition();
      }

      activeInstance = instanceAPI;

      setTimeout(function () {
        content.focus({ preventScroll: true });
      }, 0);
    }

    function closeModal() {
      if (!isOpen) return;
      isOpen = false;

      modal.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', 'false');

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus({ preventScroll: true });
      } else {
        btn.focus({ preventScroll: true });
      }

      if (activeInstance === instanceAPI) activeInstance = null;
    }

    registerGlobalListeners();

    // handle resize/orientation changes
    function resetDesktopPosition() {
      modal.style.left = '';
      if (typeof modal.style.removeProperty === 'function') {
        modal.style.removeProperty('--rigor-arrow-left');
      } else {
        modal.style.setProperty('--rigor-arrow-left', '');
      }
    }

    var instanceAPI = {
      container,
      get isOpen() { return isOpen; },
      isMobile,
      closeModal,
      updateMobilePosition,
      resetDesktopPosition,
    };

    container.__rigorInstance = instanceAPI;

    window.addEventListener('resize', () => {
      if (!instanceAPI.isMobile()) {
        instanceAPI.resetDesktopPosition();
      } else if (instanceAPI.isOpen) {
        instanceAPI.updateMobilePosition();
      }
    });

    btn.addEventListener('mouseenter', function () {
      if (isMobile() || suppressHover) return;
      clearHover();
      hoverTimeout = setTimeout(openModal, 120);
    });

    btn.addEventListener('mouseleave', function () {
      if (isMobile()) return;
      clearHover();
      hoverTimeout = setTimeout(closeModal, 120);
    });

    modal.addEventListener('mouseenter', function () {
      if (isMobile()) return;
      clearHover();
    });

    modal.addEventListener('mouseleave', function () {
      if (isMobile()) return;
      clearHover();
      hoverTimeout = setTimeout(closeModal, 120);
    });

    btn.addEventListener('click', function (e) {
      if (!isMobile()) return;

      e.preventDefault();
      e.stopPropagation();

      clearHover();
      suppressHover = true;

      if (isOpen) {
        closeModal();
      } else {
        lastFocused = document.activeElement;
        openModal();
      }

      setTimeout(function () {
        suppressHover = false;
      }, 300);
    });

    closeBtn.addEventListener('click', function () {
      closeModal();
    });
  }

  function initWhenReady() {
    document.querySelectorAll('.rigor-tooltip-wrapper').forEach(wireUp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady, { once: true });
  } else {
    initWhenReady();
  }
})();